import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Modal, Validators } from '@softline/ui-core';
import { CreateWorkNote } from '../../data/create-work-note';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { WorkNote } from '../../data/work-note';
import { CommonModule } from '@angular/common';

import { DateInputComponent } from '@softline/ui-core/date-input';
import { LoadingSpinnerComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'lib-create-work-note-dialog',
    templateUrl: './create-work-note-dialog.component.html',
    styleUrls: ['./create-work-note-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, ReactiveFormsModule,
    DateInputComponent,
    LoadingSpinnerComponent,
    TranslatePipe]
})
export class CreateWorkNoteDialogComponent
  implements Modal<CreateWorkNote['belegdatum'] | null>
{
  private close!: (_: CreateWorkNote['belegdatum'] | null) => void;

  readonly loading$ = new BehaviorSubject(false);

  readonly form = this.fb.group({
    belegdatum: [new Date().toISOString(), Validators.required()] });

  onSubmit!: (params: CreateWorkNote['belegdatum']) => Promise<{ workNote?: WorkNote }>;

  constructor(private fb: FormBuilder) {}

  registerCloseHandler(handler: (result: CreateWorkNote['belegdatum'] | null) => void) {
    this.close = handler;
  }

  async submit() {
    if (!this.form.value || !this.form?.value?.belegdatum || this.form.invalid) return;

    this.loading$.next(true);
    const result = await this.onSubmit(this.form.value?.belegdatum);
    this.loading$.next(false);

    if (result && result?.workNote) {
      this.close(this.form.value?.belegdatum as any);
    }
  }

  closeDialog() {
    this.close(null);
  }
}
